export default "__VITE_ASSET__08Tm4yZ0__"